import { createFileRoute } from "@tanstack/react-router";

import { AdminOrganizations } from "@/features/admin/screens/AdminOrganizations";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/organizations",
)({
  component: AdminOrganizations,
});
